<template>
  <div class="tab">
    <div class="page__column large-info-card mb-40">
      <div class="data large-info-card__item">
        <div class="data__name">Трудоустроен:</div>
        <div class="data__value">{{ user.profile.is_official ? 'Официально' : 'Не официально' }}</div>
      </div>
      <!--отдел в котором пользователь числится сотрудником, если пользователь является руководителем,
      то его отделы видны в блоке "подчиненные" и этот пункт не выводится-->

      <div class="data large-info-card__item" v-if="user.department || (departHeadCrutch.reverse()[0] !== null)">
        <div class="data__name">Подразделение:</div>
        <div class="data__value" v-if="user.department.name">{{ user.department.name }}</div>
        <div class="data__value" v-else-if="departHeadCrutch.reverse()[0]">{{ departHeadCrutch.reverse()[0]}}</div>
        <div class="data__value" v-else>Не указано</div>
      </div>
      <div class="data large-info-card__item">
        <div class="data__name">Должность:</div>
        <div class="data__value" v-if="this.user && this.user.position">{{ this.user.position.name }}</div>
        <div class="data__value" v-else>Не указана</div>
      </div>
      <div class="data large-info-card__item">
        <div class="data__name">Вид занятости:</div>
        <div class="data__value" v-if="this.user.employment">{{ this.user.employment.name }}</div>
        <div class="data__value" v-else>Не указан</div>
      </div>
      <div class="data large-info-card__item">
        <div class="data__name">График работы:</div>
        <div class="data__value" v-if="this.user.schedule">{{ this.user.schedule.name }}</div>
        <div class="data__value" v-else>Не указан</div>
      </div>
      <div class="data large-info-card__item">
        <div class="data__name">Дата приема:</div>
        <div class="data__value" v-if="user.profile.employment_at">{{ formatDate(user.profile.employment_at) }}</div>
        <div class="data__value" v-else>Не указана</div>
      </div>
    </div>

    <h2 class="subtitle">Организационная информация</h2>
    <!--условие для отрисовки заголовка для всех кроме гененерального-->
    <div class="page__row org-subtitle mb-20" v-if="leader">
      <span>Руководитель:</span>
    </div>
    <div class="page__row mb-40" v-if="leader">
      <!--руководитель текущего отдела в котором пользователь числится сотрудником-->
      <router-link :to="`/user/info/${leader.id}/personal`" class="user-card">
        <UserItem :name="leader.profile.name"
                  :surname="leader.profile.surname"
                  :patronymic="leader.profile.patronymic"
                  :avatar="leader.avatar"
                  :position-id="leader.position_id"
                  :user="leader"
        />
      </router-link>
    </div>

    <!--подчиненные-->
    <div class="page__column mb-40" v-if="subordinatesCount">
      <div class="page__row org-subtitle mb-20">
        Подчиненные:
      </div>
      <div class="page_column" :class="department.users.length !== 0 ? 'mb-20' : ''" v-for="department in subDepartments" :key="department.id">
        <div class="page__row department-title" v-if="department.users.length !== 0">{{ department.name }}</div>
        <div class="user-list">
          <router-link v-for="user in department.users"
                       :key="user.id"
                       :to="`/user/info/${user.id}/personal`"
                       class="user-card">
            <UserItem :name="user.profile.name"
                      :surname="user.profile.surname"
                      :patronymic="user.profile.patronymic"
                      :position-id="user.position_id"
                      :avatar="user.avatar"
                      :user="user"
            />
          </router-link>
        </div>
      </div>
    </div>
    <!--/подчиненные-->

    <div class="page__row cards-row mb-40">
      <div class="info-card">
        <h2 class="subtitle info-card__head">Учетные данные сотрудника</h2>
        <div class="data info-card__item">
          <div class="data__name">E-mail:</div>
          <div class="data__value" v-if="user.email">{{ user.email }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Телефон:</div>
          <div class="data__value" v-if="user.phone">{{ user.phone }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
      </div>

      <div class="info-card">
        <h2 class="subtitle info-card__head">Контакты</h2>
        <div class="data info-card__item">
          <div class="data__name">Корпоративный телефон:</div>
          <div class="data__value" v-if="user.profile.corp_phone">{{ user.profile.corp_phone }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Рабочий телефон:</div>
          <div class="data__value" v-if="user.profile.work_phone">{{ user.profile.work_phone }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Добавочный номер:</div>
          <div class="data__value" v-if="user.profile.work_phone_append">{{ user.profile.work_phone_append }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
      </div>

      <div class="info-card">
        <h2 class="subtitle info-card__head">Основная информация</h2>
        <div class="data info-card__item">
          <div class="data__name">Дата рождения:</div>
          <div class="data__value" v-if="user.profile.birth_at">{{ formatDate(user.profile.birth_at) }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
        <!--ОК и бухгалтерия-->
        <div class="data info-card__item" v-if="roleAccessExtendedInfo">
          <div class="data__name">Место рождения:</div>
          <div class="data__value" v-if="user.profile.birth_place">{{ user.profile.birth_place }}</div>
          <div class="data__value" v-else>Не указано</div>
        </div>
      </div>
    </div>

    <h2 class="subtitle" v-if="roleAccessExtendedInfo">Документы</h2>
    <!--ОК и бухгалтерия-->
    <div class="doc-info-card" :class="user.documents.length !== 0 ? '' : 'mb-40'" v-if="roleAccessExtendedInfo">
      <div class="data info-card__item">
        <div class="data__name">ИНН:</div>
        <div class="data__value" v-if="user.profile.inn">{{ user.profile.inn }}</div>
        <div class="data__value" v-else>Не указан</div>
      </div>
      <div class="data large-info-card__item">
        <div class="data__name">СНИЛС:</div>
        <div class="data__value" v-if="user.profile.snils">{{ user.profile.snils }}</div>
        <div class="data__value" v-else>Не указан</div>
      </div>
    </div>

    <!--ОК и бухгалтерия-->
    <div class="docs-wrap" v-if="roleAccessExtendedInfo && user.documents.length !== 0">
      <div class="doc-info-card" v-for="document in user.documents" :key="document.id">
        <h2 class="subtitle info-card__head" v-if="document.type">{{ document.type.name }}</h2>
        <div class="data info-card__item">
          <div class="data__name">Серия:</div>
          <div class="data__value" v-if="document.serial">{{ document.serial }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Номер:</div>
          <div class="data__value" v-if="document.number">{{ document.number }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Кем выдан:</div>
          <div class="data__value" v-if="document.issued_by">{{ document.issued_by }}</div>
          <div class="data__value" v-else>Не указано</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Дата выдачи:</div>
          <div class="data__value" v-if="document.date_at">{{ formatDate(document.date_at) }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Код подразделения:</div>
          <div class="data__value" v-if="document.code">{{ document.code }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Гражданство:</div>
          <div class="data__value" v-if="document.citizenship">{{ document.citizenship }}</div>
          <div class="data__value" v-else>Не указано</div>
        </div>
      </div>
    </div>
    <div class="docs-wrap docs-wrap_no-items" v-if="roleAccessExtendedInfo && user.documents.length === 0">Документы не добавлены</div>

    <!--ОК и бухгалтерия-->
    <div class="docs-wrap" v-if="roleAccessExtendedInfo && user.educations.length !== 0">
      <h2 class="subtitle">Образование</h2>
      <div class="doc-info-card" v-for="education in user.educations" :key="education.id">
        <h2 class="subtitle info-card__head" v-if="education.type">{{ education.type.name }}</h2>
        <div class="data info-card__item">
          <div class="data__name">Учебное заведение:</div>
          <div class="data__value" v-if="education.organization">{{ education.organization }}</div>
          <div class="data__value" v-else>Не указано</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Дата начала обучения:</div>
          <div class="data__value" v-if="education.start_at">{{ formatDate(education.start_at) }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Дата окончания:</div>
          <div class="data__value" v-if="education.end_at">{{ formatDate(education.end_at) }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Специальность:</div>
          <div class="data__value" v-if="education.speciality">{{ education.speciality.name }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Документ об образовании:</div>
          <div class="data__value" v-if="education.education_document">{{ education.education_document.name }}</div>
          <div class="data__value" v-else>Не указан</div>
        </div>
        <div class="data info-card__item">
          <div class="data__name">Дата выдачи документа:</div>
          <div class="data__value" v-if="education.date_at">{{ formatDate(education.date_at) }}</div>
          <div class="data__value" v-else>Не указана</div>
        </div>
      </div>
    </div>
    <div class="docs-wrap docs-wrap_no-items" v-if="roleAccessExtendedInfo && user.educations.length === 0">Информация об образовании не добавлена</div>

    <!--ОК и бухгалтерия-->
    <div class="family-wrap" v-if="roleAccessExtendedInfo && user.families.length !== 0">
      <h2 class="subtitle">Семья</h2>
      <div class="doc-info-card" v-for="member in user.families" :key="member.id">
        <h2 class="subtitle info-card__head" v-if="member.kinship">{{ member.kinship.name }}</h2>
        <div class="data info-card__item" v-if="member.name || member.surname || member.patronymic">
          <div class="data__name">ФИО:</div>
          <div class="data__value">{{ member.surname }} {{ member.name }} {{ member.patronymic }}</div>
        </div>
        <div class="data info-card__item" v-if="member.phone">
          <div class="data__name">Контакты:</div>
          <div class="data__value">{{ member.phone }}</div>
        </div>
        <div class="data info-card__item" v-if="member.birth_at">
          <div class="data__name">Дата рождения:</div>
          <div class="data__value">{{ formatDate(member.birth_at) }}</div>
        </div>
      </div>
    </div>
    <div class="family-wrap family-wrap_no-items" v-if="roleAccessExtendedInfo && user.families.length === 0">Сведения о членах семьи не добавлены</div>

    <ThePagePreloader position="component" v-if="isLoading"/>
  </div>
</template>

<script>
import UserItem from '@/components/page/user/UserItem'
import { formatDate } from '@/utils/utils'
import ThePagePreloader from '@/components/page/ThePagePreloader'

export default {
  name: 'UserDetail_personalTab',
  components: {
    UserItem,
    ThePagePreloader
  },
  props: {},
  data () {
    return {}
  },
  computed: {
    user () {
      return this.$store.getters.userForDetail
    },
    departmentHead () {
      return this.user.department && this.user.department.head_id ? this.user.department.head : null
    },
    subDepartmentParentHead () {
      return this.user.sub_department && this.user.sub_department.parent && this.user.sub_department.parent.head ? this.user.sub_department.parent.head : null
    },
    // временный (мб нет) костыль
    departHeadCrutch () {
      return this.user.subordinates.map(sub => {
        if (sub.leader === true) {
          return sub.name
        } else {
          return null
        }
      })
    },
    leader () {
      return this.user.leader
    },
    department () {
      return this.user.department
    },
    subDepartments () {
      // return this.user.subordinates
      return this.user.sub_departments
    },
    subordinatesCount () {
      let counter = 0
      this.user.sub_departments.forEach(department => {
        counter += department.users.length
      })
      // this.user.subordinates.forEach(department => {
      //   counter += department.users.length
      // })
      return counter
    },
    isLoading () {
      return this.$store.getters.userDetailIsLoading
    },
    roleAccessExtendedInfo () {
      return this.$store.getters.getRoleRightsUsers.extendedInfo
    }
  },
  methods: {
    formatDate (date) {
      return formatDate(date)
    }
  }
}

</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.tab {
  position: relative;
}
</style>
